import ReportingPortal from './index';
import BenchmarkPage from './containers/Benchmark';
import TrackingPage from './containers/Tracking';
import ProgressPage from './containers/Progress';
import DiagnosticPage from './containers/Diagnostic';
import ParentPage from './containers/Parent';
import DyslexiaRiskPage from './containers/DyslexiaRisk';
import category from '../../routesCategory';


export default [{
  path: '/teacher/reports',
  component: ReportingPortal,
  },
  {
    category: category.teacher.BENCHMARK,
    path: '/teacher/reports/type/benchmark',
    component: BenchmarkPage,
    label: 'Benchmark',
  },
  {
    category: category.teacher.PROGRESSMONITORING,
    path: '/teacher/reports/type/progress',
    component: ProgressPage,
    label: 'Progress',
  },
  {
    category: category.teacher.TRACKING,
    path: '/teacher/reports/type/tracking',
    component: TrackingPage,
    label: 'Tracking',
  },
  {
    category: category.teacher.DIAGNOSTIC,
    path: '/teacher/reports/type/diagnostic',
    component: DiagnosticPage,
    label: 'Diagnostic',
  },
  {
    category: category.teacher.PARENT,
    path: '/teacher/reports/type/parent',
    component: ParentPage,
    label: 'Parent',
  },
  {
    category: category.teacher.DYSLEXIA,
    path: '/teacher/reports/type/dyslexia',
    component: BenchmarkPage,
    label: 'Dyslexia',
  },
  {
    category: category.teacher.DYSLEXIARISK,
    path: '/teacher/reports/type/dyslexiarisk',
    component: DyslexiaRiskPage,
    label: 'Dyslexia Risk',
  },
  // TODO implement these reports
  // {
  //   path: '/teacher/reports/planning',
  //   component: PlanningPage,
  //   label: 'Planning',
  // },

  // demo
];
